const setHiddenSlides = (swiper, breakpoints) => {
	// set role="region" and aria-label="logo carousel" IF the slider
	// is active at this browser width
	const ariaDiv = swiper.el.parentElement.parentElement;
	const block = ariaDiv.parentElement.parentElement;

	// eslint-disable-next-line
	if (breakpoints != undefined) {
		if (breakpoints.slidesPerView < block.dataset.slidesLength) {
			ariaDiv.setAttribute('role', 'region');
			ariaDiv.setAttribute('aria-label', 'logo carousel');

			if (null === ariaDiv.querySelector('p.sr-only')) {
				const SRInstructions = document.createElement('p');
				SRInstructions.classList.add('sr-only');
				SRInstructions.textContent =
					'Use the next and previous buttons to navigate the carousel.';
				ariaDiv.insertBefore(SRInstructions, ariaDiv.firstChild);
			}
		} else {
			ariaDiv.removeAttribute('role');
			ariaDiv.removeAttribute('aria-label');

			const SRInstructions = ariaDiv.querySelector('p.sr-only');
			if (SRInstructions) {
				SRInstructions.remove();
			}
		}
	}

	// set hidden slides
	const slidesVisible = Math.floor(swiper.params.slidesPerView);

	const allSlides = swiper.el.querySelectorAll('.swiper-slide');
	// eslint-disable-next-line
	//debugger;
	allSlides.forEach((slide) => {
		slide.setAttribute('tabindex', -1);
		slide.setAttribute('aria-hidden', true);
		slide.querySelectorAll('a, button').forEach((item) => {
			item.setAttribute('tabindex', -1);
		});
	});

	let visibleSlide = swiper.el.querySelector('.swiper-slide-active');
	for (let i = slidesVisible; i > 0; i--) {
		if (null === visibleSlide) {
			break;
		}

		visibleSlide.setAttribute('aria-hidden', false);
		visibleSlide.setAttribute('tabindex', -1);
		visibleSlide
			.querySelectorAll('a, button')
			.forEach((item) => item.removeAttribute('tabindex'));

		visibleSlide = visibleSlide.nextElementSibling;
	}
};

document.querySelectorAll('.block-logo-carousel').forEach(function callback(logoCarousel, i) {
	const id = 'block-logo-carousel-' + i;
	const slidesLength = logoCarousel.querySelectorAll('.swiper-slide').length;

	logoCarousel.id = id;
	logoCarousel.dataset.slidesLength = slidesLength;
	if (slidesLength <= 5) logoCarousel.classList.add('slidesLength5max');
	if (slidesLength <= 3) logoCarousel.classList.add('slidesLength3max');
	if (slidesLength <= 2) logoCarousel.classList.add('slidesLength2max');

	// eslint-disable-next-line no-undef
	new Swiper(logoCarousel.querySelector('.block-logo-carousel__slider'), {
		a11y: {
			slideLabelMessage: 'slide {{index}} of {{slidesLength}}',
		},
		on: {
			init: setHiddenSlides,
			slideChangeTransitionEnd: setHiddenSlides,
			breakpoint: setHiddenSlides,
		},
		slidesPerView: 1,
		loop: true,
		navigation: {
			nextEl: logoCarousel.querySelector('.block-logo-carousel__next'),
			prevEl: logoCarousel.querySelector('.block-logo-carousel__prev'),
		},
		breakpoints: {
			576: {
				slidesPerView: Math.min(2, slidesLength),
				enabled: slidesLength > 2,
			},
			768: {
				slidesPerView: Math.min(3, slidesLength),
				enabled: slidesLength > 3,
			},
			1200: {
				slidesPerView: Math.min(5, slidesLength),
				enabled: slidesLength > 5,
			},
		},
	});
});
